import React from "react";
import { Layout } from "../../layouts/Layout";
import {
  CHECK_ICON,
} from "../../lib/assets";
import { ServicesDetailsWrapper } from "../../components/ServicesDetails/ServicesDetailsWrapper";
import { BrandSeven } from "../../components/Brand/BrandSeven";
import { ServicesDetailsFaq } from "../../components/ServicesDetails/ServicesDetailsFaq";
import { useLocation } from "react-router-dom";
import { getServices } from "../../data/services";
import { useTranslation } from "react-i18next";

const ServicesDetailsPageFour = () => {
  const { t } = useTranslation();
  const location = useLocation();
  const services = getServices(t);
  const serviceId = location.state?.serviceId;

  // Find the service details based on the serviceId
  const service = services.find(item => item.id === serviceId);

  if (!service) {
    return (
      <Layout breadcrumb={t("pages.servicesNotFound.breadcrumb")} title={t("pages.servicesNotFound.title")}>
        <ServicesDetailsWrapper serviceId={serviceId}>
          <div className="services-details-wrap">
            <div className="services-details-content">
              <h2 className="title">{t("servicesDetails.notFoundTitle")}</h2>
              <p>{t("servicesDetails.notFoundText")}</p>
            </div>
          </div>
        </ServicesDetailsWrapper>
      </Layout>
    );
  }

  return (
    <Layout breadcrumb={t("pages.services.breadcrumb")} title={service.title} footer={2}>
      {/* services-details-area */}
      <ServicesDetailsWrapper serviceId={serviceId}>
        <div className="services-details-wrap">
          <div className="services-details-content">
            <div className="sd-inner-wrap-four">
              <div className="row align-items-center">
                <div className="col-55">
                  <div className="thumb">
                    <img src={service.mainDetailImg} alt="" />
                  </div>
                </div>
                <div className="col-45">
                  <div className="content">
                    <h2 className="title">{service.subtitle}</h2>
                    <p>{service.firstParagraph}</p>
                    <ul className="list-wrap">
                      {service.completeImportantPoints.map((point, index) => (
                        <li key={index}>
                          <img src={CHECK_ICON} alt="" />
                          {point}
                        </li>
                      ))}
                    </ul>
                  </div>
                </div>
              </div>
            </div>
            <div className="services-details-list-three">
              <ul className="list-wrap">
                <li>
                  <div className="icon">
                    <i className="flaticon-family"></i>
                  </div>
                  <div className="content">
                    <h4 className="title">
                      {t("servicesDetails.competitivenessTitle")}
                    </h4>
                    <p>{t("servicesDetails.competitivenessText")}</p>
                  </div>
                </li>
                <li>
                  <div className="icon">
                    <i className="flaticon-winner"></i>
                  </div>
                  <div className="content">
                    <h4 className="title">
                      {t("servicesDetails.complianceTitle")}
                    </h4>
                    <p>{t("servicesDetails.complianceText")}</p>
                  </div>
                </li>
              </ul>
            </div>
            <p>{service.secondParagraph}</p>
            <div className="industrial-working-wrap mt-50">
              <h2 className="title-two">
                {service.secondSubTitle}
              </h2>
              <p className="info-one">
                {service.thirdParagraph}
              </p>
              <div className="blog-details-content">
                <blockquote>
                  <p>
                    {service.quote}
                  </p>
                </blockquote>
              </div>
              <p>
                {service.fourthParagraph}
              </p>
            </div>

            {/* faq */}
            <ServicesDetailsFaq faq={service.faq} />
          </div>
        </div>
      </ServicesDetailsWrapper>

      {/* brand-area */}
      <BrandSeven />
    </Layout>
  );
};

export default ServicesDetailsPageFour;
